// extracted by mini-css-extract-plugin
module.exports = {"errorPage":"__404_errorPage__i02UE","imgContainer":"__404_imgContainer__DvpAV","heading":"__404_heading__xaxme","redirectBtn":"__404_redirectBtn__X_ici"};